import { SchemaForFormData } from "@nens/shared-utils";

export const addSchema = <Type, Schema extends SchemaForFormData<Type> = SchemaForFormData<Type>>(
  schema: Schema
): SchemaForFormData<Type> => schema;
